import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-655d47f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { key: 7 }
const _hoisted_8 = { key: 8 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 点击上传 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("试用员工")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("正式员工")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "员工管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          style: {"margin-top":"10px"},
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          scroll: { x:'max-content' }
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'company' && record.company !== null )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.company.full_name), 1))
              : _createCommentVNode("", true),
            (column.key === 'part')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.department.full_name), 1))
              : _createCommentVNode("", true),
            (column.key === 'allPart')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.all_department_text, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(item), 1),
                    (record.all_department_text.length>1)
                      ? (_openBlock(), _createBlock(_component_a_divider, {
                          key: 0,
                          type: "vertical",
                          style: {"border-color":"#1890ff"}
                        }))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'avatar')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 3,
                  src: record.avatar,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'birthday')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (record.birthday !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.dayjs((record.birthday)*1000).format('YYYY-MM-DD')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'entry_date')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (record.entry_date !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.dayjs((record.entry_date)*1000).format('YYYY-MM-DD')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'sex')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.sex == 0 ? '男' : '女'), 1))
              : _createCommentVNode("", true),
            (column.key === 'test')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.test == 0 ? '正式员工' : '试用员工'), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "删除该数据?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.visible) = $event)),
      title: "员工管理",
      onOk: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onSubmit('formRef'))),
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: _ctx.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "姓名",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入姓名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "用户名",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.username,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.username) = $event)),
                  placeholder: "请输入用户名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "头像",
              name: "avatar"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  "onUpdate:file-list": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileList) = $event)),
                  headers: _ctx.uploadHeaders,
                  action: _ctx.uploadAction,
                  data: _ctx.uploadFormData,
                  onChange: _ctx.handleChange2,
                  showUploadList: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_outlined),
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                _createVNode(_component_a_image, {
                  src: _ctx.formState.avatar,
                  style: {"width":"50%"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "所属公司",
              name: "company_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.formState.company_id,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.company_id) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择所属公司",
                  onChange: _ctx.getpart
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treeData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.full_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "主部门",
              name: "department_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.formState.department_id,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.department_id) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择所属部门"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.full_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "全部部门",
              name: "all_department_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.formState.all_department_id,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.all_department_id) = $event)),
                  mode: "tags",
                  style: {"width":"100%"},
                  placeholder: "请选择所属部门"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.full_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "职位",
              name: "position"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.position,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.position) = $event)),
                  placeholder: "请输入职位"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "详细地址",
              name: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.address,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.address) = $event)),
                  placeholder: "请输入详细地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "入职日期",
              name: "entry_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.formState.entry_date,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.entry_date) = $event)),
                  style: {"width":"100%"},
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "工号",
              name: "job_number"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.job_number,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.job_number) = $event)),
                  placeholder: "请输入工号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "私人号码",
              name: "personnel_number"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.personnel_number,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.personnel_number) = $event)),
                  placeholder: "请输入私人号码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "电话",
              name: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.phone,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.phone) = $event)),
                  placeholder: "请输入电话"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "教育经历",
              name: "record_of_formal_schooling"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.record_of_formal_schooling,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.record_of_formal_schooling) = $event)),
                  placeholder: "请输入教育经历"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "性别",
              name: "sex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.sex,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.sex) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "生日",
              name: "birthday"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.formState.birthday,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.birthday) = $event)),
                  placeholder: "请选择生日",
                  style: {"width":"100%"},
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "邮箱",
              name: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.email,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.email) = $event)),
                  placeholder: "请输入邮箱"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "员工类型",
              name: "test"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.test,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.test) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.remark,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formState.remark) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}